import type {JourneyType} from '../../analytics/chatbot/types';

import * as React from 'react';

import {FilterCard} from './';
import Checkbox from 'src/components/lib/checkbox';

import css from './journey-filters-card.css';


type Props = {
  onSave?: (e: React.SyntheticEvent) => unknown;
  onCancel?: (e: React.SyntheticEvent) => unknown;
  onJourneyTypeChange: (e: React.SyntheticEvent<HTMLInputElement>) => unknown;
  selectedJourneyTypes: string[];
  journeyTypes?: JourneyType[];
};

const defaultRecipientTypes: Array<JourneyType> = [];

const JourneyFilterCard = ({
  onSave,
  onCancel,
  journeyTypes = defaultRecipientTypes,
  onJourneyTypeChange,
  selectedJourneyTypes = [],
  // @ts-expect-error - TS2339 - Property 'cardLabel' does not exist on type 'Props'.
  cardLabel = 'Journey',
}: Props) => (
  <FilterCard header={cardLabel} onSave={onSave} onCancel={onCancel}>
    <section className={css.section}>
      <ul className={css.checklist}>
        {journeyTypes.map(({journey_id, journey_name}) => (
          <li key={journey_id}>
            <label className={css.label}>
              <Checkbox
                className={css.checkbox}
                name={String(journey_id)}
                // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
                checked={selectedJourneyTypes.includes(journey_id)}
                onChange={onJourneyTypeChange}
              />
              {journey_name}
            </label>
          </li>
        ))}
      </ul>
    </section>
  </FilterCard>
);

export default JourneyFilterCard;
